export enum FileTypeEnum {
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  VIDEO = 'VIDEO',
  XML = 'XML',
  SHEET = 'SHEET'
}

export type IFile = {
  path: string
  name: string
  size: number // in bytes
  type: FileTypeEnum
  extension?: string
  caption?: string
}

export type ISecureFile = {
  uploadId: string
  name: string
  size: number
  type: FileTypeEnum
  extension?: string
  caption?: string
}
